import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRovoRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-rovo',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo',
	exact: true,
};
